import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CONSTANTS_MESSAGE } from "config/constants/Message";
import { actionDismissLoading, actionManageMessage, actionMessage, actionShowLoading } from "redux/shared/SharedSlice";
import { apiCallConfigOptimizeCfe, apiCallConfigUpdateNumbers, apiCallImportarCfe, apiCallConfigGetParameter, apiCallConfigUpdateParameter } from "../api/ConfigServices";

const oInitialState = {
  aParameters: [],
};

export const actionConfigUpdateNumbers = createAsyncThunk("config/updateNumbers", async(args, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallConfigUpdateNumbers();
    oThunk.dispatch(
      actionMessage({
        message: oSuccess.message || "Numeradores actualizados correctamente",
        type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
      }),
    );
    oThunk.dispatch(actionDismissLoading());
    return true;
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionConfigOptimizeCfe = createAsyncThunk("config/optimizeCfe", async(args, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallConfigOptimizeCfe();
    oThunk.dispatch(
      actionMessage({
        message: oSuccess.message || "Tabla de envíos de CFE optimizada correctamente",
        type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
      }),
    );
    oThunk.dispatch(actionDismissLoading());
    return true;
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionConfigImportCfe = createAsyncThunk("efactura/cfe/recibidos/importar", async(args, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallImportarCfe();
    oThunk.dispatch(
      actionMessage({
        message: oSuccess.message || "Se han importado las compras correctamente",
        type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
      }),
    );
    oThunk.dispatch(actionDismissLoading());
    return true;
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionConfigGetParameter = createAsyncThunk("config/getParameter", async(sName, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallConfigGetParameter(sName);
    oThunk.dispatch(actionDismissLoading());
    return oSuccess.data;
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionConfigUpdateParameter = createAsyncThunk("config/updateParameter", async({ sName, sValue }, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallConfigUpdateParameter(sName, sValue);
    oThunk.dispatch(actionDismissLoading());
    oThunk.dispatch(actionMessage({
      message: oSuccess.message || "Parámetro actualizado correctamente",
      type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
    }));
    return { sName, sValue };
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

const ConfigSlice = createSlice({
  name: "ConfigSlice",
  initialState: oInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(actionConfigGetParameter.fulfilled, (oState, oAction) => {
      if (oAction.payload) {
        const oParam = oAction.payload[0];
        const exists = oState.aParameters.find(p => p.parNom === oParam.parNom);
        if (!exists) oState.aParameters.push(oParam);
        else oState.aParameters = oState.aParameters.map(p =>
          p.parNom === oParam.parNom ? oParam : p,
        );
      }
    });
    builder.addCase(actionConfigUpdateParameter.fulfilled, (oState, oAction) => {
      if (oAction.payload) {
        oState.aParameters = oState.aParameters.map(p =>
          p.parNom === oAction.payload.sName
            ? { ...p, parVal: oAction.payload.sValue }
            : p,
        );
      }
    });
  },
});

export const selectConfigState = ({ ConfigSlice: oState }) => oState;
export default ConfigSlice.reducer;
